import { Link } from 'react-router-dom';
import RevealLines from '@/components/base/RevealLines';
import { featuredCase } from '@/mocks/site';

export default function About() {
  return (
    <>
      <section id="about" aria-label="Who we are" className="relative flex min-h-[100svh] items-center bg-accent-100 py-28 md:py-36">
        <div className="w-full px-4 md:px-6 text-center">
          <p className="font-label text-[11px] uppercase tracking-[0.18em] text-foreground-700" data-reveal="up">Who we are / 01</p>
          <RevealLines
            lines={['The best experiences', 'aren\u2019t just seen.', 'They\u2019re felt.']}
            className="mx-auto mt-8 max-w-[1320px] font-extrabold tracking-[-0.055em] leading-[0.92] text-foreground-950 text-[clamp(2.4rem,7.4vw,8rem)]"
          />
        </div>
      </section>

      <section aria-label={`Featured experience: ${featuredCase.title}`} className="relative bg-foreground-950 text-background-50">
        <div className="relative min-h-[100svh] overflow-hidden" data-scrub="zoom">
          <img src={featuredCase.src} alt={featuredCase.alt} className="absolute inset-0 h-full w-full object-cover object-top will-change-transform" />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/45 via-foreground-950/15 to-foreground-950/80" />
          <div className="relative flex min-h-[100svh] flex-col justify-between px-4 md:px-6 pt-24 pb-10 md:pt-28 md:pb-12">
            <p className="font-label text-[11px] uppercase tracking-[0.18em] text-background-100">Featured experience / {featuredCase.category} / {featuredCase.location}</p>
            <div className="grid grid-cols-1 md:grid-cols-12 items-end gap-8">
              <div className="md:col-span-8">
                <RevealLines
                  as="h2"
                  lines={[featuredCase.title]}
                  className="font-extrabold uppercase tracking-[-0.06em] leading-[0.85] text-[clamp(3.5rem,12vw,12rem)]"
                />
                <p className="mt-6 text-sm md:text-base leading-relaxed text-background-100 max-w-[440px]" data-reveal="up">{featuredCase.summary}</p>
              </div>
              <div className="md:col-span-4 flex md:justify-end">
                <Link to="/work" className="group w-24 h-24 md:w-28 md:h-28 flex flex-col items-center justify-center rounded-full bg-primary-500 text-background-50 font-label text-[10px] uppercase tracking-[0.16em] hover:bg-background-50 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
                  <span className="w-5 h-5 flex items-center justify-center text-lg transition-transform group-hover:rotate-45"><i className="ri-arrow-right-up-line" /></span>
                  More work
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}